import React, { useState, useCallback, useEffect } from 'react'
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'
import AppDispatcher from '../../../dispatchers/AppDispatcher'

import {
  CapitalButton,
} from '../Navigation/Buttons'

import {
  SelectInput,
} from '../Inputs/Inputs'

import styles from '../../../../css/home.module.css'

function ExistingCustomerStep1 ({
  intl: { formatMessage, locale },
  customerOptions,
  defaultCustomer,
  step1Callback,
  onSubmit,
}) {
  const [language, setLanguage] = useState(locale)
  const [invalid, setInvalid] = useState(true)
  const [saved, setSaved] = useState(false)
  const [company, setCompany] = useState(defaultCustomer)

  useEffect(() => {
    AppDispatcher.dispatch({
      action: 'get-user',
    })

    if (defaultCustomer) {
      setInvalid(false)
    }
  }, [defaultCustomer])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [])

  const handleChange = useCallback((field, value) => {
    const newValue = value

    // Update the appropriate state based on field
    if (field === 'language') setLanguage(newValue)
    if (field === 'invalid') setInvalid(newValue)
    if (field === 'saved') setSaved(newValue)
    if (field === 'company') setCompany(newValue)

    isValid()
  }, [])

  const submitData = useCallback(() => {
    step1Callback(company)
  }, [company, step1Callback])

  const isValid = useCallback(() => {
    if (company !== '') {
      setInvalid(false)
    } else {
      setInvalid(true)
    }
  }, [company])

  let saveButtonStyle = `${styles.saveButton} saveButton`

  if (invalid) {
    saveButtonStyle = `${styles.saveButton} saveButton`
  } else if (saved === true) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonSuccess}`
  } else if (saved === 'error') {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonError}`
  }

  return (
    <div>
      <div className={styles.userInviteInput}>
        <section className={styles.userInput}>
          <FormattedMessage
            id='addCustomer.customer'
            defaultMessage='Customer'
            description='Customer label'
            tagName='h5'
          />
          <div className={styles.userInputValueEdit}>
            <SelectInput
              options={customerOptions}
              childChange={childChange}
              field='company'
              value={company}
            />
          </div>
        </section>
      </div>

      <CapitalButton
        text={formatMessage({
          id: 'customer.nextButton',
          defaultMessage: 'Next',
          description: '',
        })}
        buttonFunction={submitData}
        hSize='h2'
        style={saveButtonStyle}
        disabled={invalid}
      />
    </div>
  )
}

export default injectIntl(ExistingCustomerStep1)
